import React, { useState } from 'react'
import { Controller } from 'react-hook-form'
import checkGreenIcon from '../../../assets/images/check-green.svg'
import crossOrangeIcon from '../../../assets/images/cross-orange.svg'
import DateRange from '../DateRange'
import {
  ErrorText,
  InputWrap,
  Label,
  Row,
  ValidationIcon,
  Wrap,
} from './input.style'
import { inputTypes } from './inputTypes'
import './style.css'

const Input = (props) => {
  const {
    control,
    name,
    validation,
    defaultValue,
    styleRow,
    styleContainer,
    disabled,
    label,
    smallLabel,
    labelStyle,
    error,
    style,
    placeholderColor,
    success,
    relativeIcon,
    type = 'text',
    transparent,
    isSearchOpened,
    handleChange,
    handleShowDateRange,
    reset,
    styleError,
    noLimit,
    dateRangeStyle,
    addNew,
    onAddNew,
    multiSelectItemColor,
  } = props

  const [showDateRange, setShowDateRange] = useState(false)

  const rules = {
    email: {
      validate: (value) => {
        return !!value?.trim()
      },
      ...validation,
    },
    text: {
      validate: (value) => {
        return !!value?.trim()
      },
      ...validation,
    },
    password: {
      validate: (value) => {
        return !!value?.trim()
      },
      ...validation,
    },
  }

  const onDateRangeClick = (e) => {
    if (e.target.classList.contains('date_range_click')) {
      setShowDateRange(!showDateRange)
      handleShowDateRange && handleShowDateRange(!showDateRange)
    }
  }

  const onClick = (e) => {
    if (type === 'date_range') {
      onDateRangeClick(e)
    }
  }

  return (
    <Controller
      control={control}
      name={name}
      rules={
        rules[type] || {
          ...validation,
        }
      }
      defaultValue={defaultValue || null}
      render={({ onChange, value }) => (
        <Row style={styleRow} type={type}>
          <Wrap style={styleContainer} disabled={disabled}>
            {label && (
              <Label
                smallLabel={smallLabel}
                style={labelStyle}
                required={validation?.required}
              >
                <div>
                  {label}
                  <span>*</span>
                </div>
                {addNew && (
                  <div
                    style={{
                      color: '#70A3EC',
                      fontSize: 12,
                      textDecoration: 'underline',
                      cursor: 'pointer',
                    }}
                    onClick={onAddNew}
                  >
                    Add New
                  </div>
                )}
              </Label>
            )}
            <InputWrap
              error={error}
              style={{
                ...style,
                overflow: type === 'date' ? 'visible' : 'hidden',
              }}
              transparent={transparent}
              placeholderColor={placeholderColor}
              className={type === 'date_range' && 'date_range_click'}
              onClick={(e) => onClick(e)}
              multiSelectItemColor={multiSelectItemColor}
            >
              {inputTypes({ ...props, onChange, value, reset })[type]}
            </InputWrap>
            {type === 'date_range' && (
              <DateRange
                visible={isSearchOpened && showDateRange}
                onChange={(date) => {
                  onChange(`${date.start}±${date.end}`)
                  handleChange && handleChange(`${date.start}±${date.end}`)
                }}
                onClose={() => setShowDateRange(false)}
                noLimit={noLimit}
                defaultValue={defaultValue}
                style={dateRangeStyle}
                value={value}
              />
            )}
            {error && <ErrorText style={styleError}>{error}</ErrorText>}
          </Wrap>
          {(error || success) && (
            <ValidationIcon
              src={success ? checkGreenIcon : crossOrangeIcon}
              smallLabel={smallLabel}
              alt={success ? 'check-icon' : 'cross-icon'}
              relativeIcon={relativeIcon}
              label={label}
            />
          )}
        </Row>
      )}
    />
  )
}

export default Input
